export function setCookie(key, value, expirationDays) {
	const date = new Date();
	date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000)); // установка срока действия в днях
	const expires = "expires=" + date.toUTCString();
	document.cookie = key + "=" + value + ";" + expires + ";path=/"; // запись значения в Cookie
}